// Recuerda el municipio elegido en la app de operadores (build tenant-agnostic).
//
// La app arranca en el host neutro (app.vortigon.com/ingresar) y, tras resolver
// el municipio (por ubicación o texto), salta a <slug>.vortigon.com. Guardamos
// el slug en una COOKIE de dominio padre `.vortigon.com`, compartida entre el
// host neutro y el del municipio (mismo patrón que la vinculación del SOS, ver
// lib/sos/device-binding.ts): así el próximo arranque en app.vortigon.com lee lo
// que se eligió y va derecho, sin volver a preguntar. En dev (localhost) la
// cookie va host-only.

const TENANT_COOKIE = "vortigon_tenant";
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;
const SLUG_RE = /^[a-z0-9-]{1,63}$/;

function cookieDomainAttr(): string {
  try {
    const m = window.location.hostname.match(/(?:^|\.)(vortigon\.com)$/);
    return m ? `; domain=.${m[1]}` : "";
  } catch {
    return "";
  }
}

export function readChosenTenantSlug(): string | null {
  try {
    const prefix = `${TENANT_COOKIE}=`;
    const hit = document.cookie.split("; ").find((c) => c.startsWith(prefix));
    if (!hit) return null;
    const slug = decodeURIComponent(hit.slice(prefix.length));
    return SLUG_RE.test(slug) ? slug : null;
  } catch {
    return null;
  }
}

export function storeChosenTenantSlug(slug: string): void {
  if (!SLUG_RE.test(slug)) return;
  try {
    const secure = window.location.protocol === "https:" ? "; secure" : "";
    document.cookie =
      `${TENANT_COOKIE}=${encodeURIComponent(slug)}` +
      `; path=/; max-age=${ONE_YEAR_SECONDS}; samesite=lax` +
      `${cookieDomainAttr()}${secure}`;
  } catch {}
}

export function clearChosenTenantSlug(): void {
  try {
    document.cookie =
      `${TENANT_COOKIE}=; path=/; max-age=0; samesite=lax` +
      `${cookieDomainAttr()}`;
  } catch {}
}

/**
 * URL del municipio a la que saltar dentro del webview. Deriva el dominio base
 * del host actual (app.vortigon.com -> vortigon.com; en dev, localhost) y arma
 * `https://<slug>.<base>`. La navegación cross-subdominio se queda DENTRO de la
 * app por server.allowNavigation ["*.vortigon.com"] (capacitor.config.ts).
 */
export function tenantUrl(slug: string): string {
  const { protocol, hostname, port, host } = window.location;
  const m = hostname.match(/vortigon\.com$/);
  if (!m) {
    // Dev / localhost: no hay subdominios de tenant; el escape hatch de
    // tenant-host mapea localhost -> lincoln, así que quedarse en el mismo host
    // alcanza para probar el flujo.
    return `${protocol}//${host}`;
  }
  const portSuffix = port ? `:${port}` : "";
  return `${protocol}//${slug}.vortigon.com${portSuffix}`;
}
